import { remoteConfig } from '../../firebase/firebaseSetup';

import ConfigInterface from './configInterface';
import { getValue, fetchAndActivate } from 'firebase/remote-config';

const defaultConfig = {
    animals: {
        species: ['bovine', 'porcine']
    }
};
export default class ConfigService {
    /**
     * Get the image background url for the login form server or return a default one
     * @param serverConfig ConfigInterface
     * @returns Image Url
     */
    getBackgroundImage = (serverConfig: ConfigInterface): string => {
        const configBg = serverConfig.app?.loginBackgrounds
            ? serverConfig.app.loginBackgrounds
            : ['/images/app/login_background.jpg'];
        const index = Math.floor(Math.random() * configBg.length);
        return configBg[index];
    };

    /**
     * Get the application global configuration.
     * @returns {Promise<ConfigInterface>}
     */
    get = (): Promise<ConfigInterface> => {
        return new Promise((resolve, reject) => {
            let config = {
                app: {
                    loginBackground: '/images/app/login_background.jpg'
                }
            } as ConfigInterface;
            fetchAndActivate(remoteConfig)
                .then((c) => {
                    const serverConfig = JSON.parse(
                        getValue(remoteConfig, 'config').asString() || '{}'
                    );
                    config = {
                        ...defaultConfig,
                        ...serverConfig,
                        app: {
                            loginBackground:
                                this.getBackgroundImage(serverConfig),
                            ...serverConfig.app
                        }
                    };
                    resolve(config as ConfigInterface);
                })
                .catch((e) => {
                    console.error('Error loading config: ', e);
                    reject(config);
                });
        });
    };
}
